import React, { useContext, useEffect } from "react";
import { authProfile } from "../../api/mainAPI";
import { Navigate, Outlet, RouteProps } from "react-router-dom";
import { MainContext, MainContextState } from "../../context/MainContext";

const AuthRoute: React.FC<RouteProps> = ({ children, ...props }) => {
    const [loaded, setLoaded] = React.useState(true);
    const { setUser } = useContext<Partial<MainContextState>>(MainContext);
    useEffect(() => {
        authProfile(
            extData => {
                const { data: innerData } = extData;
                if (innerData) {
                    localStorage.setItem("admin_role", String(!!innerData.role));
                    localStorage.setItem("employee_type", String(innerData?.employee_data?.employee_type));
                    localStorage.setItem("employee_center_id", String(innerData?.employee_data?.center.id));
                    localStorage.setItem("employee_id", String(innerData.id));
                    setUser && setUser(innerData);
                }
                setLoaded(!!innerData);
            },
            () => {
                setLoaded(false);
            },
        );
    }, []);

    if (!loaded) {
        return <Navigate to="/authorization" />;
    }
    return <Outlet />;
};

export default AuthRoute;
